<button
  type="button"
  nz-button
  nzType="link"
  nz-dropdown
  [nzDropdownMenu]="menu"
  nzTrigger="click"
  class="batch-print-btn"
  [disabled]="!canBatchPrint"
  [nzLoading]="opening"
  nz-tooltip
  [nzTooltipTitle]="'Batch Printing'"
>
  <span nz-icon nzType="printer"></span>
</button>

<nz-dropdown-menu #menu="nzDropdownMenu">
  <ul nz-menu>
    <ng-container *ngIf="visibleFormats.length > 0; else noFormats">
      <li
        nz-menu-item
        *ngFor="let format of visibleFormats"
        (click)="openFormat(format)"
      >
        <span>{{ format.displayName }}</span>
        <nz-tag *ngIf="format.isEInvFormat" [nzColor]="'warning'">
          eInv
        </nz-tag>
      </li>
    </ng-container>
    <ng-template #noFormats>
      <li nz-menu-item disabled>No formats available</li>
    </ng-template>
    <li nz-menu-divider></li>
    <li nz-menu-item (click)="reloadFormats()" [nzDisabled]="refreshing">
      Reload formats
    </li>
  </ul>
</nz-dropdown-menu>
